import React from 'react'
import { useRouter } from 'next/router'
import Redirect from '@components/redirect'

const CoachingCenterGiftsPage = () => {
  const router = useRouter()
  const slug = 'pga-coaching-center-at-pga-frisco/gifts'

  if (router.pathname === '/coachingcenter/gifts') {
    return <Redirect to={`/${slug}`} />
  }

  return null
}

export default CoachingCenterGiftsPage
